import { LanguageType } from "types/language";
import enLocale from "../../assets/locales/en.json";
import heLocale from "../../assets/locales/he.json";
import arLocale from "../../assets/locales/ar.json";
import frLocale from "../../assets/locales/fr.json";
import nlLocale from "../../assets/locales/nl.json";
import ruLocale from "../../assets/locales/ru.json";

const Languages: LanguageType[] = [
  {
    key: "en",
    label: "English",
    serverKey: "ENGLISH",
    isRtl: false,
    source: enLocale,
  },
  {
    key: "he",
    label: "עברית",
    serverKey: "HEBREW",
    isRtl: true,
    source: heLocale,
  },
  {
    key: "ar",
    label: "عربيه",
    serverKey: "ARABIC",
    isRtl: true,
    source: arLocale,
  },
  {
    key: "fr",
    label: "Français",
    serverKey: "FRENCH",
    isRtl: false,
    source: frLocale,
  },
  {
    key: "nl",
    label: "Nederlands",
    serverKey: "DUTCH",
    isRtl: false,
    source: nlLocale,
  },
  {
    key: "ru",
    label: "Русский",
    serverKey: "RUSSIAN",
    isRtl: false,
    source: ruLocale,
  },
];

export default Languages;
